import { Stack } from '@mui/material';
import { Share } from '../../../Share';
import { ReferralRequest } from './ReferralRequest';
import { useNavigate } from 'react-router-dom';
import { ISuppliersResult } from 'API/Suppliers/suppliers';
import { useIsDesktop } from 'Hooks';

interface IRequestSharePanel {
  data: ISuppliersResult;
}

export const RequestSharePanel = ({ data }: IRequestSharePanel) => {
  const navigate = useNavigate();
  const isDesktop = useIsDesktop();

  const requestHandler = (event: React.MouseEvent) => {
    navigate('/universalRequest/0/1/80');
  };

  return (
    <Stack direction='row' alignItems='center' width='fit-content' gap='16px'>
      {isDesktop && <ReferralRequest onClick={requestHandler} />}
      <Share data={data} />
    </Stack>
  );
};
